exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.why-modal .modal-dialog{width:538px}}@media (max-width:768px){.why-modal .modal-dialog{width:335px;position:absolute;top:20%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/payments/signup/bank_account_info/whyModal.css
// module id = 760
// module chunks = 0